<script setup>
import dayjs from "dayjs";
import { computed } from "vue";

const props = defineProps({
  journey: { type: Object, required: true },
});

const currency = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
});
const formatDate = (value) =>
  value ? dayjs(value).format("ddd D MMM YYYY, HH:mm") : "Not provided";
const formatMoney = (value) =>
  value === null || value === undefined
    ? "Not provided"
    : currency.format(Number(value));
const formatBoolean = (value) =>
  value === null || value === undefined ? "Not provided" : value ? "Yes" : "No";
const formatRate = (value) =>
  value === null || value === undefined
    ? "Not provided"
    : `${formatMoney(value)}/hour`;
const route = computed(
  () =>
    [props.journey.pickup_postcode, props.journey.dropoff_postcode]
      .filter(Boolean)
      .join(" → ") || "Not provided",
);
const fields = computed(() => [
  ["Journey ID", props.journey.external_journey_id],
  ["Group ID", props.journey.group_id || "Not provided"],
  ["Commissioner", props.journey.commissioner || "Not provided"],
  ["Patient", props.journey.patient_name || "Not provided"],
  ["Appointment", formatDate(props.journey.appointment_at)],
  ["Pickup", formatDate(props.journey.pickup_at)],
  ["Expiry", formatDate(props.journey.expires_at)],
  ["Route", route.value],
  ["Journey type", props.journey.journey_type || "Not provided"],
  ["ETA", props.journey.eta || "Not provided"],
  ["Service", props.journey.service || "Not provided"],
  ["Mobility", props.journey.mobility || "Not provided"],
  ["Price", formatMoney(props.journey.price)],
  ["Waiting rate", formatRate(props.journey.additional_hourly_rate)],
  ["Status", props.journey.status || "Not provided"],
  ["Journey action", props.journey.journey_action || "Not provided"],
  ["Escorts", props.journey.escorts ?? "Not provided"],
  ["ASAP", formatBoolean(props.journey.asap)],
  ["Acknowledged", formatBoolean(props.journey.acknowledged)],
  ["Aborted", formatBoolean(props.journey.aborted)],
  ["Regular booking", formatBoolean(props.journey.regular_booking)],
  ["Last synced", formatDate(props.journey.synced_at)],
]);
</script>

<template>
  <FormBox header="Platform 365 journey">
    <dl class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      <div
        v-for="([label, value], index) in fields"
        :key="`${label}-${index}`"
        class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-700 dark:bg-slate-800"
      >
        <dt
          class="text-xs font-semibold uppercase tracking-wide text-slate-400"
        >
          {{ label }}
        </dt>
        <dd class="mt-1 text-sm text-slate-800 dark:text-slate-100">
          {{ value }}
        </dd>
      </div>
    </dl>
    <div
      v-if="journey.reason_for_booking"
      class="mt-4 rounded-xl border border-slate-200 px-4 py-3 dark:border-slate-700"
    >
      <div class="text-xs font-semibold uppercase tracking-wide text-slate-400">
        Reason for booking
      </div>
      <p
        class="mt-1 whitespace-pre-line text-sm text-slate-800 dark:text-slate-100"
      >
        {{ journey.reason_for_booking }}
      </p>
    </div>
  </FormBox>
</template>
